import { render, staticRenderFns } from "./ToeflScoreComponent.vue?vue&type=template&id=993346d6&scoped=true&"
import script from "./ToeflScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflScoreComponent.vue?vue&type=style&index=0&id=993346d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993346d6",
  null
  
)

export default component.exports